import { getFirstPossibleRoute } from '@/router/utils/getFirstPossibleRoute'
import { type Route } from '@/types/route'

import { artisansAndAdminsRoutes } from './artisans-and-admins'
import { billingReportsRoutes } from './billing-reports'
import { diningHallRoutes } from './dining-hall'
import { doctorsRoutes } from './doctors'
import { documentForAppsRoutes } from './documents-for-apps'
import { examPlannerRoutes } from './exam-planner'
import { housesRoutes } from './houses'
import { infoboardsRoutes } from './infoboards'
import { teamsRoutes } from './teams'

export const administrationChildrenRoutes = [
  ...artisansAndAdminsRoutes,
  ...housesRoutes,
  ...teamsRoutes,
  ...doctorsRoutes,
  ...examPlannerRoutes,
  ...documentForAppsRoutes,
  ...diningHallRoutes,
  ...billingReportsRoutes,
  ...infoboardsRoutes
] satisfies Route[]

export const administrationRoutes = [
  {
    path: '',
    name: 'administration' as const,
    component: () => import('@/views/Layouts/RouterView.vue'),
    meta: {
      tab: 'administration',
      title: 'Administration'
    },
    redirect: () => getFirstPossibleRoute(administrationChildrenRoutes),
    children: administrationChildrenRoutes
  }
] satisfies Route[]
